
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { TeamMember } from '@/interfaces/team';

@Options({})
export default class TeamMemberCard extends Vue {
  @Prop({ required: true }) member!: TeamMember;

  getSocialIcon(platform: string): string {
    const icons: Record<string, string> = {
      twitch: 'mdi-twitch',
      twitter: 'mdi-twitter',
      facebook: 'mdi-facebook',
      instagram: 'mdi-instagram',
      youtube: 'mdi-youtube'
    };
    return icons[platform] || 'mdi-link';
  }
}
